import { instance } from "@/apis";
import { useMutation } from "@tanstack/react-query";

export const useUpdateChatMemoMutation = () => {
  return useMutation({
    mutationFn: ({
      chatId,
      memoId,
      content,
      title,
    }: {
      chatId: string;
      memoId: string;
      content: string;
      title: string;
    }) =>
      instance.put(`/api/df/user/chat/${chatId}/memo/${memoId}`, {
        title,
        content,
      }),
  });
};
